









import Vue, { PropType } from 'vue';
import SectionItemForm, {
  FormDataInterface,
} from '@/containers/cv-section-link-item/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionLinkItemStoreNew from '@/store/modules/cvSectionLinkItemNew';
import { CvSectionLink } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    SectionItemForm,
  },
  props: {
    cvId: {
      type: [String, Number],
      required: true,
    },
    section: {
      type: Object as PropType<CvSectionLink>,
      required: true,
    },
  },
  methods: {
    async onSubmit({ title, url }: FormDataInterface) {
      await this.$store.dispatch(
        CvSectionLinkItemStoreNew.CreateCvSectionLinkItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_link_id: this.section.id,
          },
          body: {
            title,
            url,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.created));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
      this.$router.push({ name: 'cv_edit_path' });
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
  },
});
